import { useAuth } from '@dotfile/frontend/shared/common';
import { useContactCasesQuery } from '@dotfile/shared/data-access-client-portal';
import { ContactStateEnum } from '@dotfile/shared/domain';

import { ContactAuthContext } from '../contexts';

export const useContactCases = () => {
  const { auth } = useAuth<ContactAuthContext>();
  const isNotStateResumed = auth.state !== ContactStateEnum.resumed;
  const isNotAuthenticated = !auth.isAuthenticated;

  return useContactCasesQuery({
    skip: isNotAuthenticated || isNotStateResumed,
  });
};
